import React, { useRef } from "react";
import { Search } from "lucide-react";

const SearchBox = ({
  value,
  onChange,
  onSearch,
  placeholder = "Search...",
}) => {
  const inputRef = useRef(null);

  /**
   * The ring is `focus-within`, so it stays lit for as long as focus is anywhere in
   * the box. Submitting is the end of the interaction — the results land elsewhere
   * — so focus is let go and the ring goes with it.
   */
  const runSearch = (e) => {
    onSearch?.();
    inputRef.current?.blur();
    e?.currentTarget?.blur?.();
  };


  return (
    <div
      className="relative flex items-center border border-gray-300 dark:border-acs-dark-border 
      bg-white dark:bg-acs-dark-surface rounded-full px-3 py-1.5 w-80
      focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500/20
      transition-none"
    >
      <input
        ref={inputRef}

        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") runSearch(e);
        }}
        className="w-full pr-7 outline-none focus:outline-none focus:ring-0
          text-fluid-sm text-gray-800 dark:text-acs-dark-text
          placeholder-gray-400 dark:placeholder-acs-dark-subtext bg-transparent"
      />
      <button
        type="button"
        onClick={runSearch}
        className="absolute right-3 text-gray-500 dark:text-acs-dark-subtext
          hover:text-[#223688] dark:hover:text-acs-dark-hover transition-none"
      >
        <Search size={18} strokeWidth={2} />
      </button>
    </div>
  );
};

export default SearchBox;